/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { projectFieldSettingsControllerFindForScope } from "./projectFieldSettingsControllerFindForScope";
import { projectFieldSettingsControllerReplaceForScope } from "./projectFieldSettingsControllerReplaceForScope";

export function projectFieldSettingsService() {
  return { projectFieldSettingsControllerFindForScope, projectFieldSettingsControllerReplaceForScope }
}